import { combineReducers } from 'redux'
import appReducer from './appReducer'
import authReducer from './authReducer'
import dataReducer from './dataReducer'

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  data: dataReducer,
})

export default rootReducer
